import { IBreadcrumbItem, Pivot, PivotItem } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomBreadcrumb } from "../SharedComponents/CustomBreadcrumb";
import ExploreSupport from "./ExploreSupport";
import ReportCatalog from "./ReportCatalog";

const DEFAULT_TAB = "productReports";

const ExploreReports = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabKeyFromUrl = searchParams.get("tab");
  const [selectedKey, setSelectedKey] = useState(tabKeyFromUrl || DEFAULT_TAB);

  const breadcrumbProps = {
    items: [
      { text: "Home", key: "explore-products-to-home", onClick: () => navigate("/") },
      { text: "Explore Reports", key: "reports", isCurrentItem: true }
    ] as IBreadcrumbItem[],
    styles: {
      root: {
        fontSize: 14,
        margin: 0,
        paddingLeft: 8,
        "--itemLink-color": "rgb(0, 120, 212)"
      },
      item: {
        fontSize: "inherit"
      },
      itemLink: {
        fontSize: "inherit",
        color: "var(--itemLink-color)",
        ":hover": {
          background: "none",
          textDecoration: "underline",
          color: "var(--itemLink-color)"
        }
      }
    }
  };

  useEffect(() => {
    if (tabKeyFromUrl && tabKeyFromUrl !== selectedKey) {
      setSelectedKey(tabKeyFromUrl);
    }
  }, [tabKeyFromUrl, selectedKey]);

  const handleTabChange = (item?: PivotItem) => {
    const key = item?.props?.itemKey || DEFAULT_TAB;
    setSelectedKey(key);
    searchParams.set("tab", key);
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <div>
      <CustomBreadcrumb {...breadcrumbProps} />
      <div style={{ padding: "0 20px 0 20px" }}>
      <h1 style={{ marginBottom: "16px", fontSize: "40px", fontWeight: "bold", color: "hsl(222.2, 84%, 4.9%)" }}>
        Explore Reports
      </h1>
      <Pivot
        selectedKey={selectedKey}
        onLinkClick={handleTabChange}
        aria-label="Explore Reports Tabs"
      >
        <PivotItem headerText="Product Reports" itemKey="productReports">
          <ReportCatalog />
        </PivotItem>
        <PivotItem headerText="Support Catalog" itemKey="supportCatalog">
          <ExploreSupport />
        </PivotItem>
      </Pivot>
      </div>
    </div>
  );
};

export default ExploreReports;
